const DASHBOARD_NAME_UPDATED = (context, name) => {
  context.name = name;
};

const SET_DASHBOARD_TASK_PER_PAGE = (context, perPage) => {
  context.perPage = perPage;
  localStorage.setItem("dashboard-tasks-per-page", perPage);
};

const DESELECT_ALL_TASKS = (context) => {
  context.selectedTasks = [];
};

const SELECT_TASK = (context, task) => {
  context.selectedTasks.push(task);
};

const DESELECT_TASK = (context, task) => {
  context.selectedTasks.splice(context.selectedTasks.findIndex((x) => x.id === task.id), 1);
};

const SET_LABEL_IDS = (context, labelIds) => {
  context.labelIds = labelIds;
  localStorage.setItem("dashboard-tasks-label-ids", JSON.stringify(labelIds));
};

const SET_ACTIVE_CALLBACKS = (context, activeCallbacks) => {
  context.activeCallbacks = activeCallbacks;
};

const SET_FETCHING_ACTIVE_CALLBACKS = (context, fetchingActiveCallbacks) => {
  context.fetchingActiveCallbacks = fetchingActiveCallbacks;
};
export default {
  DASHBOARD_NAME_UPDATED,
  SET_DASHBOARD_TASK_PER_PAGE,
  DESELECT_ALL_TASKS,
  SELECT_TASK,
  DESELECT_TASK,
  SET_LABEL_IDS,
  SET_ACTIVE_CALLBACKS,
  SET_FETCHING_ACTIVE_CALLBACKS,
};
